<ng-container *ngIf="!loading">
  <td [@fadeIn]>{{recommendation.ComponentName}}</td>
  <td [@fadeIn]>{{recommendation.Side}}</td>
  <td [@fadeIn]>{{recommendation.Position}}</td>
  <td [@fadeIn]>{{recommendation.RecommendationName}}</td>
  <td class="right-align" [@fadeIn]>${{recommendation.LabourCost}}</td>
  <td class="right-align" [@fadeIn]>${{recommendation.PartsCost}}</td>
  <td class="right-align" [@fadeIn]>${{recommendation.MiscCost}}</td>
  <td class="right-align" [@fadeIn]>${{recommendation.TotalCost}}</td>
  <td class="right-align" [@fadeIn]>{{recommendation.ActionDateString}}</td>
  <td class="right-align" [@fadeIn]>{{recommendation.StartActionAtSmu}} hrs</td>
  <td class="right-align" [@fadeIn]>{{recommendation.Severitycategory}}</td>
  <td class="right-align" [@fadeIn]>{{recommendation.CompleteActionBySmu - recommendation.StartActionAtSmu}} hrs</td>
  <td style="padding: 8px 16px;" [@fadeIn]><span [matTooltip]="recommendation.Comment">{{recommendation.Comment | slice:0:20}}{{recommendation.Comment.length > 20 ? '...' : ''}}</span></td>
   <td style="padding: 8px 16px;" [@fadeIn]><span >{{recommendation.StatusName }}</span></td>
  <td [@fadeIn] class="right-align">
    <i *ngIf="!isDeleting && isInterpreter" class="material-icons menu-icon" [matMenuTriggerFor]="menu">more_vert</i>
    <mat-spinner *ngIf="isDeleting" diameter="14"></mat-spinner>
  </td>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="openEditRecommendation()">
      <span>Edit</span>
    </button>
    <button mat-menu-item (click)="deleteRecommendation()">
      <span>Delete</span>
    </button>
  </mat-menu>
</ng-container>
<ng-container *ngIf="loading">
  <td colspan="12">
    <div class="ph-item">
      <div class="ph-row">
        <div class="ph-col-12"></div>
      </div>
    </div>
  </td>
</ng-container>
